import React from 'react';
import PropTypes from 'prop-types';
import { Button, FlexButtonGroup } from '@pattern-library/buttons';
import PasswordReveal from '@pattern-library/password-reveal';

const propTypes = {
    buttonProps: PropTypes.objectOf(PropTypes.string).isRequired,
    newPasswordInputProps: PropTypes.objectOf(PropTypes.string).isRequired,
    confirmPasswordInputProps: PropTypes.objectOf(PropTypes.string).isRequired,
    passwordRestrictions: PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.string)
    })
};

function UpdatePasswordForm(props) {
    const { buttonProps, newPasswordInputProps, confirmPasswordInputProps, passwordRestrictions } =
        props;

    const instructions = passwordRestrictions.items.length ? (
        <ul className="asc-ul asc-mtb-0">
            {passwordRestrictions.items.map((restriction, index) => (
                <li key={index}>{restriction}</li>
            ))}
        </ul>
    ) : null;

    return (
        <div className="ul-login-form">
            <PasswordReveal
                isRequired
                preventAutofill
                subtext={instructions}
                {...newPasswordInputProps}
            />

            <PasswordReveal isRequired preventAutofill {...confirmPasswordInputProps} />

            <FlexButtonGroup alignment="center" className="asc-mt-4 asc-mb-0">
                <Button type="submit" className="asc-mtb-0" {...buttonProps} />
            </FlexButtonGroup>
        </div>
    );
}

UpdatePasswordForm.propTypes = propTypes;
export default UpdatePasswordForm;
